var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.345,
    height: 36.345
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-airplane",
    d: "M26.356 23.504a32.485 32.485 0 00-.816-.788l-2.965-2.814a.117.117 0 01-.036-.116l2.156-10.823a1.012 1.012 0 00-.273-.932l-1.055-1.055c-.25-.25-.583-.084-.725.236l-4.129 8.593a.123.123 0 01-.2.04l-5.532-5.372a.507.507 0 01-.153-.436l.352-3.649a1 1 0 00-.29-.833l-.747-.747a.251.251 0 00-.406.067L9.364 8.82a1.027 1.027 0 01-.53.53l-3.946 2.173a.251.251 0 00-.067.405l.743.744a1.019 1.019 0 00.833.29l3.716-.356a.516.516 0 01.435.152l5.3 5.541a.125.125 0 01-.04.2l-8.595 4.133c-.321.142-.485.476-.236.725l1.055 1.056a1 1 0 00.93.271l10.824-2.146a.124.124 0 01.116.035l2.815 2.966c.138.157.637.664.788.816 1.973 1.972 3.857 2.583 4.646 1.794s.182-2.667-1.795-4.645z",
    fill: "#a28d50"
  })));
}

export default SvgPlaneIcon;